export const GLOBAL_ACCEPTANCE_PATH = "/global-acceptance";
export const FAQS_PATH = `${GLOBAL_ACCEPTANCE_PATH}/faqs`;
